// extracted by mini-css-extract-plugin
module.exports = {"chip-skeleton-container":"VIP_ChipListSkeleton__chip-skeleton-container","chipSkeletonContainer":"VIP_ChipListSkeleton__chip-skeleton-container"};